module.exports = __webpack_public_path__ + "static/media/pro_symbol.18680836.png";